<ul role="list" class="divide-y divide-gray-100 m-5" *ngIf="tenants$ | async as tenants">
    <li *ngFor="let tenant of tenants" class="flex justify-between gap-x-6 py-5">
      <div class="flex min-w-0 gap-x-4">
        <img
          *ngIf="tenant.logoUrl"
          class="h-auto w-32 flex-none bg-gray-50"
          [src]="tenant.logoUrl"
          alt="{{ tenant.name }} logo"
        />
        <div class="min-w-0 flex-auto">
          <p class="text-sm font-semibold leading-6 text-gray-900">
            <a href="#" class="hover:underline">{{ tenant.name }}</a>
          </p>
          <p class="mt-1 flex text-xs leading-5 text-gray-500">
            <a href="mailto:{{ tenant.contactEmail }}" class="truncate hover:underline">{{ tenant.contactEmail }}</a>
          </p>
        </div>
      </div>
      <div class="flex shrink-0 items-center gap-x-6">
        <div class="hidden sm:flex sm:flex-col sm:items-end">
          <p class="text-sm leading-6 text-gray-900">{{ tenant.type === 'corporate' ? 'Corporate' : 'Shop' }}</p>
        </div>
        <div class="relative flex-none">
          <button
            type="button"
            class="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900"
            (click)="loadChildShops(tenant._id)"
          >
            <span class="sr-only">Open child shops</span>
            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                d="M10 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM10 8.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM11.5 15.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
              />
            </svg>
          </button>
        </div>
      </div>
  
      <!-- Child Shops Section -->
      <div *ngIf="selectedTenantId === tenant._id" class="mt-4">
        <ul role="list" class="divide-y divide-gray-100 ml-10" *ngIf="childShops$ | async as childShops">
          <li *ngFor="let shop of childShops" class="py-3 flex items-center justify-between">
            <div class="flex items-center">
              <img class="h-10 w-10 rounded-full" [src]="shop.logoUrl" alt="" />
              <div class="ml-4">
                <div class="text-sm font-medium text-gray-900">{{ shop.name }}</div>
                <div class="text-sm text-gray-500">{{ shop.contactEmail }}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </li>
  </ul>
  